import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=2bad2580&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=ts&"
export * from "./Product.vue?vue&type=script&lang=ts&"
import style0 from "./Product.vue?vue&type=style&index=0&id=2bad2580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad2580",
  null
  
)

component.options.__file = "Product.vue"
export default component.exports